import React from "react"

export const getDefaultStyle = (
	isFullscreen: boolean
): React.CSSProperties => ({
	width: "100%",
	height: isFullscreen ? "100vh" : "400px",
	borderRadius: isFullscreen ? 0 : 5,
})

export const buttonStyle: React.CSSProperties = {
	height: 28,
	padding: "0 8px",
	display: "flex",
	alignItems: "center",
	gap: 4,
	backgroundColor: "white",
	border: "none",
	borderRadius: 2,
	boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 4px -1px",
	cursor: "pointer",
	fontSize: 12,
	color: "rgba(0, 0, 0, 0.87)",
}

export const loadingOverlayStyle: React.CSSProperties = {
	position: "absolute",
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	backgroundColor: "rgba(255, 255, 255, 0.8)",
	zIndex: 10,
}

export const errorContainerStyle: React.CSSProperties = {
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	backgroundColor: "#f5f5f5",
	color: "#ff4d4f",
}

export const vehiclePanelStyle: React.CSSProperties = {
	position: "absolute",
	top: 70,
	left: 10,
	zIndex: 100,
	backgroundColor: "white",
	borderRadius: 2,
	boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 4px -1px",
	padding: "10px 14px",
	fontFamily:
		"-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
	minWidth: 200,
}

export const vehiclePanelCloseStyle: React.CSSProperties = {
	position: "absolute",
	top: 6,
	right: 6,
	cursor: "pointer",
	padding: 4,
	lineHeight: 1,
}

export const vehiclePanelHeaderStyle: React.CSSProperties = {
	display: "flex",
	alignItems: "center",
	gap: 8,
	marginBottom: 8,
}

export const vehiclePanelIconStyle: React.CSSProperties = {
	width: 28,
	height: 28,
	background: "linear-gradient(135deg, #52c41a 0%, #389e0d 100%)",
	borderRadius: 6,
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
}

export const vehiclePanelRowStyle: React.CSSProperties = {
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
}

export const poiButtonContainerStyle: React.CSSProperties = {
	position: "absolute",
	top: 40,
	right: 10,
	zIndex: 100,
}

export const legendContainerStyle: React.CSSProperties = {
	display: "flex",
	flexDirection: "column",
	gap: 6,
	padding: "8px 12px",
	backgroundColor: "white",
	borderRadius: "0 0 5px 5px",
	borderTop: "1px solid #f0f0f0",
	fontSize: 12,
	color: "rgba(0, 0, 0, 0.65)",
}

export const legendItemStyle: React.CSSProperties = {
	display: "flex",
	alignItems: "center",
	gap: 6,
}

export const legendSectionTitleStyle: React.CSSProperties = {
	fontWeight: 600,
	fontSize: 11,
	color: "rgba(0, 0, 0, 0.45)",
	textTransform: "uppercase",
	letterSpacing: 0.5,
}

export const mapStyles = {
	hidePOIs: [
		{
			featureType: "poi",
			elementType: "all",
			stylers: [{ visibility: "off" }],
		},
		{
			featureType: "transit",
			elementType: "all",
			stylers: [{ visibility: "off" }],
		},
	],
}
